import FadeInAnimation from "../FadeInAnimation/FadeInAnimation";

const SectionHeader = ({ heading }) => {
  return (
    <FadeInAnimation custom={1}>
      <div className="font-second_font text-center md:w-4/12 mx-auto pt-6 pb-4 md:pt-10 md:pb-6">
        <h3 className="md:text-4xl text-3xl text-white text-gray-900">
          {heading}
        </h3>
      </div>
    </FadeInAnimation>
  );
};

export default SectionHeader;
